import { render, staticRenderFns } from "./LocationModule.vue?vue&type=template&id=1fbd0014&"
import script from "./LocationModule.vue?vue&type=script&lang=js&"
export * from "./LocationModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports